// ======================================================================
// File Name       : ServiceGroupConfirmContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as modalActions from '../../actions/ModalAction';
import * as serviceGroupActions from '../../actions/ServiceGroupAction';
import { SERVICE_GROUP_LIST } from '../../constants/PathConstants';
import { REDIRECT_MODAL } from '../../constants/ServiceGroupConstants';
import { hideLoading, showLoading } from '../../utils/PageUtils';
import ModalWrapper from '../modal/ModalWrapper';
import ServiceGroupDetail from './ServiceGroupDetail';
import ServiceGroupServiceRelation from './ServiceGroupServiceRelation';
import ServiceGroupSuperUserRelation from './ServiceGroupSuperUserRelation';
import { SHOW_MESSAGE } from '../../constants/actionTypes/message';

let okBtnClick = false;
class ServiceGroupConfirmContainer extends Component {
  constructor(props) {
    super(props);
    this.handleOKBtn = this.handleOKBtn.bind(this);
    this.handleBackBtn = this.handleBackBtn.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  handleBackBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].CANCEL));
  }

  handleOKBtn() {
    const { dispatch, modalId } = this.props;
    if (!okBtnClick) {
      okBtnClick = true;
      dispatch(showLoading());
      dispatch(serviceGroupActions.saveServiceGroup()).then(() => {
        okBtnClick = false;
        dispatch(hideLoading());
        this.props.history.push(SERVICE_GROUP_LIST);
      }).catch((error) => {
        dispatch(hideLoading());
        const messageInfo = {
          statusCd: error.statusCd,
          message: error.message,
          targetModal: true,
          messageType: 'danger',
        };
        dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].ERROR));
        dispatch({ type: SHOW_MESSAGE, ...messageInfo });
        okBtnClick = false;
      });
    }
  }

  hideModal() {
    this.props.hideModal();
  }

  getModalOptions() {
    return {
      title: '以下の内容で登録します',
      footerBtns: [
        { name: '戻る', onClick: this.handleBackBtn, variant: 'default' },
        { name: 'OK', onClick: this.handleOKBtn, variant: 'primary' },
      ],
    };
  }

  render() {
    const { serviceGroup } = this.props;
    const { editingServiceGroup, editingServiceGroupService, editingServiceGroupSuperUser } = serviceGroup;
    const { serviceGroupSecernId } = editingServiceGroup;
    return (
      <ModalWrapper {...this.getModalOptions()} dialogClassName="group-detail-dialog" hideModal={this.hideModal}>
        <Form className='form-horizontal'>
          <ServiceGroupDetail editingServiceGroup={editingServiceGroup} serviceGroupSecernId={serviceGroupSecernId} />
          <ServiceGroupServiceRelation
            editingServiceGroupService={editingServiceGroupService}
          />
          <ServiceGroupSuperUserRelation
            editingServiceGroupSuperUser={editingServiceGroupSuperUser}
          />
        </Form>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceGroup } = state;
  return { serviceGroup };
};
export default connect(mapStateToProps)(ServiceGroupConfirmContainer);
